import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {Range} from "@/modules/redactor/models/utils/Range";
import {Currency} from "@/modules/redactor/models/currency/Currency";

export class TreasureLowerCapConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(TreasureLowerCapConfig, v) : SKIP;
        }, (v) => {
            return deserialize(TreasureLowerCapConfig, v);
        });
    }

    constructor() {
        super();

        this._enabled = false;
        this._duration = 0;

        this._sinkPrice = 0;
        this._sinkCount = null;

        this._collectDataDuration = 0;

        this._lowerPrice = [];
        this._defaultPrice = [];
    }

    get enabled() {
        return this._enabled;
    }

    set enabled(value) {
        this._enabled = value;
    }

    get duration() {
        return this._duration;
    }

    set duration(value) {
        this._duration = value;
    }

    get sinkCount() {
        return this._sinkCount;
    }

    set sinkCount(value) {
        this._sinkCount = value;
    }

    get sinkPrice() {
        return this._sinkPrice;
    }

    set sinkPrice(value) {
        this._sinkPrice = value;
    }

    get collectDataDuration() {
        return this._collectDataDuration;
    }

    set collectDataDuration(value) {
        this._collectDataDuration = value;
    }

    get lowerPrice() {
        return this._lowerPrice;
    }

    set lowerPrice(value) {
        this._lowerPrice = value;
    }

    get defaultPrice() {
        return this._defaultPrice;
    }

    set defaultPrice(value) {
        this._defaultPrice = value;
    }

    valid() {

        if (!Number.isInteger(this.duration) || this.duration < 0) {
            return false;
        }

        if (!Number.isInteger(this.collectDataDuration) || this.collectDataDuration <= 0) {
            return false;
        }

        if (!Number.isInteger(this.sinkPrice) || this.sinkPrice <= 0) {
            return false;
        }

        if (!this.sinkCount || !this.sinkCount.valid()) {
            return false;
        }

        if (!this.lowerPrice || this.lowerPrice.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.defaultPrice || this.defaultPrice.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.lowerPrice.length !== this.defaultPrice.length || this.defaultPrice.length === 0) {
            return false;
        }

        return true;
    }

    empty() {
        return this.collectDataDuration <= 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TreasureLowerCapConfig());
        } else if (target instanceof TreasureLowerCapConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TreasureLowerCapConfig, {
    _enabled: alias("enabled", Schema.primitive()),
    _duration: alias("duration", Schema.primitive()),

    _sinkPrice: alias("sink_price", Schema.primitive()),
    _sinkCount: alias("sink_count", Range.schema()),

    _collectDataDuration: alias("collect_data_duration", Schema.primitive()),

    _lowerPrice: alias("lower_price", list(Currency.schema())),
    _defaultPrice: alias("default_price", list(Currency.schema()))
});
